<div class="cemetery flex flex-column-reverse md:flex-row">
	<div class="txt flex flex-column">
		<p [innerHTML]="dead.text"></p>
		<div class="winners" *ngIf="showWinnerList">
			<hr/>
			<b>{{ acertador() }}:</b>
			<div class="winnersList">{{ winnerList.join(", ") }}</div>
		</div>
	</div>
	<div class="flex flex-column">

		<div class="box">
			<mag-image
				class="image"
				[id]="dead.image_id"
				[width]="300"
				[height]="400"
				[alt]="dead.name"
			/>
			<div class="name">{{ dead.name }}</div>
			<div class="death-date">
				<i class="fa fa-cross"></i> {{ dead.death_date | date: 'dd/MM/yyyy' }}
			</div>
			<div class="age">
				{{ dead.age }} anos
				<p-progressBar [value]="ageProgress" [showValue]="false" />
			</div>
			<div class="points">
				{{ dead.points }} pontos
				<p-progressBar [value]="pointsProgress" [showValue]="false" />
			</div>
			<div class="winners">
				{{ acertador() }}
				<p-progressBar [value]="winnersProgress" [showValue]="false" />
			</div>
		</div>
		
		<app-block-350-300 />

	</div>
</div>
